import { RepeatByDateKind } from '@planning/app/api'
import { ICarrierVisitSchedule } from '@planning/components/CarrierVisitSchedule'
import { FieldStore, FormStore, validateSubForm } from '@tom-ui/utils'
import { Dayjs } from 'dayjs'
import { action, makeObservable } from 'mobx'

export class VesselVisitScheduleFormStore extends FormStore<ICarrierVisitSchedule> {
  showTimingOptions: FieldStore<number>
  selectedRadioOption: FieldStore<string>
  repeatEvery: FieldStore<number>
  repeatBy: FieldStore<RepeatByDateKind>
  endsOn: FieldStore<Dayjs | undefined>
  endsAfter: FieldStore<number | undefined>

  constructor(initialValues?: Partial<ICarrierVisitSchedule>) {
    super(initialValues)

    makeObservable(this, {
      setData: action,
      reset: action,
    })

    this.showTimingOptions = new FieldStore<number>(initialValues?.showTimingOptions ?? 0)
    this.selectedRadioOption = new FieldStore<string>(initialValues?.selectedRadioOption ?? 'on')
    this.repeatEvery = new FieldStore<number>(initialValues?.repeatEvery ?? 1)
    this.repeatBy = new FieldStore<RepeatByDateKind>(
      initialValues?.repeatBy ?? RepeatByDateKind.Week,
    )
    this.endsOn = new FieldStore<Dayjs | undefined>(initialValues?.endsOn, val =>
      this.selectedRadioOption.value === 'on' && (val === undefined || !val.isValid())
        ? 'fieldIsRequired'
        : undefined,
    )
    this.endsAfter = new FieldStore<number | undefined>(initialValues?.endsAfter, val =>
      this.selectedRadioOption.value === 'after' && (val === 0 || val === undefined)
        ? 'fieldIsRequired'
        : undefined,
    )
  }

  setData(data: Partial<ICarrierVisitSchedule>) {
    this.showTimingOptions.setValue(data.showTimingOptions ?? 0)
    this.selectedRadioOption.setValue(data.selectedRadioOption ?? 'on')
    this.repeatEvery.setValue(data.repeatEvery ?? 1)
    this.repeatBy.setValue(data.repeatBy ?? RepeatByDateKind.Week)
    this.endsOn.setValue(data.endsOn)
    this.endsAfter.setValue(data.endsAfter)
  }

  get data(): ICarrierVisitSchedule {
    return {
      showTimingOptions: this.showTimingOptions.value,
      selectedRadioOption: this.selectedRadioOption.value,
      repeatEvery: this.repeatEvery.value,
      repeatBy: this.repeatBy.value,
      endsOn: this.endsOn.value,
      endsAfter: this.endsAfter.value,
    }
  }

  validate = () => {
    return validateSubForm(this)
  }

  reset() {
    this.setData(this.initialValues)
  }
}
